var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 83,
    viewBox: "0 0 79 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5025 82.443H17.8465C15.6611 82.4404 13.5659 81.5711 12.0204 80.0258C10.475 78.4806 9.60545 76.3855 9.60254 74.2V64.832H38.0885C39.4141 64.8304 40.685 64.3031 41.6223 63.3658C42.5597 62.4284 43.087 61.1576 43.0885 59.832V21.313C43.087 19.9874 42.5597 18.7166 41.6223 17.7792C40.685 16.8419 39.4141 16.3146 38.0885 16.313H9.60254V8.244C9.60492 6.05829 10.4742 3.96278 12.0198 2.41724C13.5653 0.871709 15.6608 0.00238225 17.8465 0L57.4725 0L78.7475 21.275V74.2C78.7446 76.3856 77.875 78.4809 76.3293 80.0262C74.7836 81.5715 72.6882 82.4406 70.5025 82.443V82.443ZM62.6145 53.372V58.525H73.2925V53.372H62.6145ZM54.0265 53.372V58.525H59.2025V53.372H54.0265ZM62.6145 44V49.153H73.2925V44H62.6145ZM54.0265 44V49.153H59.2025V44H54.0265ZM62.6145 34.626V39.779H73.2925V34.626H62.6145ZM54.0265 34.626V39.779H59.2025V34.626H54.0265ZM54.8265 5.352V23.988H73.4265L54.8265 5.352Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1139 58.882H5.91394C4.58835 58.8805 3.3175 58.3532 2.38016 57.4158C1.44282 56.4785 0.915528 55.2076 0.91394 53.882L0.91394 27.269C0.915528 25.9434 1.44282 24.6726 2.38016 23.7353C3.3175 22.7979 4.58835 22.2706 5.91394 22.269H33.1139C34.4395 22.2706 35.7104 22.7979 36.6477 23.7353C37.5851 24.6726 38.1124 25.9434 38.1139 27.269V53.882C38.1126 55.2077 37.5854 56.4787 36.648 57.4161C35.7106 58.3535 34.4396 58.8807 33.1139 58.882Z",
    fill: "#D84E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1666 36.7519C30.1666 37.9334 29.9792 39.058 29.6043 40.1259C29.2294 41.1938 28.6898 42.0856 27.9855 42.8013C27.5538 43.2443 27.0766 43.6533 26.554 44.0282C26.0428 44.4031 25.4748 44.7212 24.85 44.9825C24.2252 45.2438 23.5435 45.4482 22.8051 45.5959C22.0781 45.7436 21.2601 45.8175 20.3513 45.8175H17.0113V54.1162H10.6382V28.7428H20.4876C21.9531 28.7428 23.2141 28.8791 24.2706 29.1518C25.3385 29.4131 26.3041 29.8334 27.1675 30.4128C28.1218 31.049 28.8602 31.901 29.3828 32.9689C29.9054 34.0254 30.1666 35.2864 30.1666 36.7519ZM23.6231 36.9052C23.6231 36.1895 23.4527 35.5761 23.1119 35.0649C22.771 34.5423 22.3621 34.1844 21.8849 33.9913C21.2828 33.73 20.7035 33.5823 20.1468 33.5483C19.6015 33.5028 18.8574 33.4801 17.9145 33.4801H17.0113V41.0802H17.4544C18.0565 41.0802 18.6245 41.0745 19.1584 41.0631C19.6924 41.0518 20.1582 41.012 20.5558 40.9439C20.8966 40.8871 21.2544 40.7791 21.6293 40.6201C22.0156 40.4497 22.3109 40.2622 22.5154 40.0577C22.9471 39.6374 23.2368 39.2 23.3845 38.7456C23.5435 38.2912 23.6231 37.6777 23.6231 36.9052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7698,
    y: 59.6055,
    width: 0.516932,
    height: 5.42871,
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.67,
    height: 82.443,
    fill: "white",
    transform: "translate(0.0775146)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.77c4b8a32ece681173b54264c6d4b9a3.svg";
export { ForwardRef as ReactComponent };